import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import axios from "axios";
import {IErrors} from "@/model/IErrors";
import {IWebhoook} from "@/model/Webhook/webhoookInterfaces";
import {RootState} from "@/store/RootState";
import responseHandler from "@/plugins/errorHandling";
import {settings} from "@/plugins/settings";
import Vue from "vue";

interface WebhookState {
  webhooks: IWebhoook[];
  webhook: IWebhoook|null;
  logs: string[];
  errors: IErrors;
}


const state: WebhookState = {
  webhooks: [],
  webhook: null,
  logs: [],
  errors: {}
}


const getters: GetterTree<WebhookState, RootState>  = {
  webhookList: (state): IWebhoook[] => state.webhooks,
  webhook: (state): IWebhoook|null => state.webhook,
  logs: (state): string[] => state.logs,
  errors: (state) => state.errors,
  error: (state): boolean => Object.keys(state.errors).length > 0
};

const actions: ActionTree<WebhookState, RootState>  = {
  clearWebhooks: ({commit}): any => commit('clearWebhooks'),

  fetchWebhooks: ({ commit }, filters): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/',
      method: 'GET',
      params: filters
    }),
    commit,
    'webhooksLoaded'
  ),

  fetchWebhook: ({commit}, webhookId): any => responseHandler.handle(
      () => axios( {
        url: settings.endpoint + 'webhooks/' + webhookId,
      }),
      commit,
      'webhookLoaded'
  ),

  fetchUserWebhooks: ({ commit }, {userId, filters}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/users/' + userId,
      method: 'GET',
      params: filters
    }),
    commit,
    'webhooksLoaded'
  ),
  fetchLogs: ({commit}: any, {userId}: any): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/users/' + userId + '/logs',
      method: 'GET'
    }),
    commit,
    'fetchLogs'
  ),
  clearLogs:  ({commit}): any => {
    commit('clearLogs');
  },
  createWebhook: ({ commit }, data): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/',
      method: 'POST',
      data,
    }),
    commit,
    'webhookCreated'
  ),

  deleteWebhook: ({ commit }, id: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/' + id,
      method: 'DELETE',
    }),
    commit,
    'webhookDeleted'
  ),

  sendSampleCall: ({commit}, id: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'webhooks/' + id + '/sampleCall',
      method: 'POST',
    }),
    commit,
    'webhookSampleCallSent'
  ),

  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },

  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  },

  resetErrors: ({commit}, index: any): any => {
    commit('resetErrors', index);
  },
};

const mutations: MutationTree<WebhookState> = {
  webhooksLoaded(state, payload: IWebhoook) {
    state.webhooks = state.webhooks.concat(payload);
  },

  webhookDeleted(state, payload: IWebhoook) {
    state.webhooks = state.webhooks.filter(webh => webh.id !== payload.id);
  },

  webhookCreated(state, payload: IWebhoook) {
    state.webhooks.push(payload)
  },

  clearWebhooks(state) {
    state.webhooks = [];
  },

  fetchLogs(state, payload) {
    state.logs = payload;
  },

  clearLogs(state) {
    state.logs = [];
  },

  errors(state, payload: IErrors) {
    state.errors = payload;
  },

  cleanError(state, index: string) {
    Vue.delete(state.errors, index);
  },

  resetErrors(state) {
    state.errors = {};
  },

  webhookLoaded(state, payload) {
    state.webhook = payload;
  }

};


const namespaced: boolean = true;

export const webhookModule: Module<WebhookState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
